import * as React from 'react'
import { IconWrapper } from '../IconWrapper'
import { IconProps } from '../iconConstants'

export const DropdownIcon = ({ title, titleId, ...props }: IconProps) => (
    <IconWrapper {...props}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            fill="none"
            viewBox="0 0 24 24"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                fill="currentColor"
                stroke="currentColor"
                strokeLinejoin="round"
                d="m12 17.5-2.5-3h5l-2.5 3ZM12 6.5l-2.5 3h5l-2.5-3Z"
            />
        </svg>
    </IconWrapper>
)
